import React, {Component} from 'react';
import AppNavigation from '../AppNavigation';
import AppFooter from '../AppFooter';
import SubSendEndorsement from '../Subcomponents/SendEndorsement';
import withRouter from '../Functions/WithRouter';

class OrgSendEndorsement extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const { org, endorsementId, requestId } = this.props.params

      let selectedEndorsement = null
      let objectId = null
      let benchmark = null
      if (this.props.location && this.props.location.state) {
        selectedEndorsement = this.props.location.state.selectedEndorsement
        objectId = this.props.location.state.objectId
        benchmark = this.props.location.state.benchmark
      }

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let activeOrg = localStorage.getItem('activeOrg');
      let username = localStorage.getItem('username');
      let orgFocus = localStorage.getItem('orgFocus');
      const orgLogo = localStorage.getItem('orgLogo');

      this.setState({ endorsementId, requestId, selectedEndorsement, objectId, benchmark, orgCode: org,
        org, email, username, orgFocus, roleName, orgLogo
      })
    }

    render() {

        return (
            <div>
              <AppNavigation fromOrganization={true} org={this.state.org} orgFocus={this.state.orgFocus} history={this.props.navigate} />

              <div className="width-70-percent top-margin-2-percent center-horizontally medium-shadow max-width-1400">
                <div className="card">
                  <SubSendEndorsement history={this.props.navigate} requestId={this.state.requestId} endorsementId={this.state.endorsementId} selectedEndorsement={this.state.selectedEndorsement} objectId={this.state.objectId} benchmark={this.state.benchmark} orgCode={this.state.orgCode}/>
                </div>
              </div>

              {(this.state.org) && (
                <div>
                  {AppFooter(this.props.navigate,this.state.org,this.state.orgLogo)}
                </div>
              )}
            </div>

        )
    }
}

export default withRouter(OrgSendEndorsement)
